import { render, staticRenderFns } from "./VideoSearch.vue?vue&type=template&id=1cb7c27f&scoped=true&"
import script from "./VideoSearch.vue?vue&type=script&lang=js&"
export * from "./VideoSearch.vue?vue&type=script&lang=js&"
import style0 from "./VideoSearch.vue?vue&type=style&index=0&id=1cb7c27f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb7c27f",
  null
  
)

export default component.exports